<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-receipt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 5a2 2 0 00-2-2H8a2 2 0 00-2 2v36.687a2 2 0 002.931 1.77L15.5 40l7.608 3.79a2 2 0 001.784 0L32.5 40l6.569 3.457A2 2 0 0042 41.687V5zM10 7h28v31.374l-5.45-2.868-8.55 4.26-8.55-4.26L10 38.374V7zm23 18a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h18zm1-9a1 1 0 00-1-1H15a1 1 0 00-1 1v2a1 1 0 001 1h18a1 1 0 001-1v-2z"/></svg>
</template>
<script>

export default {
  name: 'IconReceipt',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
